import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconWind: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconWind"><Path d="M2.5 12H19.5C20.6046 12 21.5 11.1046 21.5 10C21.5 8.89543 20.6046 8 19.5 8C18.82 8 18.2193 8.33935 17.8579 8.85793M2.5 7.5H11.5C12.6046 7.5 13.5 6.60457 13.5 5.5C13.5 4.39543 12.6046 3.5 11.5 3.5C10.82 3.5 10.2193 3.83935 9.85793 4.35793M2.5 16.5H15.5C16.6046 16.5 17.5 17.3954 17.5 18.5C17.5 19.6046 16.6046 20.5 15.5 20.5C14.82 20.5 14.2193 20.1607 13.8579 19.6421" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconWind;
